<template>
       <div class="ccpay-orderSates"  style="height:100%" >
                <div class="ccpay-order-tab">
                    <div @click="changeActive(1)">
                        <span :class="isactive==1?'class-tab-sp':''" >已完成</span>
                    </div>
                    <div @click="changeActive(2)">
                         <span :class="isactive==2?'class-tab-sp':''">已取消</span>
                    </div>
                </div>
                  <div style="height:3rem" ></div>
         <mt-loadmore :top-method="loadTop"   ref="loadmore" style="background:white">
               <div class="ccpay-order-content" style="height:auto;flex:1" >
                <mt-search
                style="height:60px;"
                v-model="searchvalue"
                cancel-text="取消"
                placeholder="查询：名称或订单编号"
                >
                </mt-search>
                <div class="selectTime" 
                    @click="selectData">
                    <span >开始时间：</span>
                    <span>{{this.selectedValue}}</span>
                 </div>
                <div class="selectTime" 
                    @click="selectData2">
                    <span >结束时间：</span>
                 <span>{{this.selectedValue2}}</span>
                 </div>
                   <mt-button   type="primary" style="marginBottom:10px;marginTop:10px;width:100%" @click="search()"  >查询</mt-button>
                    <div class="ccapy-order-card" v-for='(item,index) in data' :key="index"  @click="detail(item.order_no)" >
                        <div class="ccpay-cls-act-div" v-show="item.isclass"></div>
                            <p class="ccpay-order-card-hed fz14"><span>
                                <span class="c-r-c-g fw-60"  :style="{'color':item.side=='BUY'?'#54BCA5':'#CA595B'}" style="margin-right">
                                {{item.side=='BUY'?'买-' + item.kyc_name :'卖-' + item.kyc_name }} </span>
                                </span>
                                <span class="c-r-c-g fw-60" v-show="isactive==1&&item.side=='BUY'">已完成</span>
                                 <span class="c-r-c-br fw-60" v-show="isactive==1&&item.side!='BUY'">已完成</span>
                                <span class="c-r-c-g " style="color:#ccc" v-show="isactive==2">已取消</span>
                            </p>
                            <p class="ccpay-order-c-spbed fz14"    >
                                <span>{{moment(item.created_time).format("MM-DD HH:mm")}}</span>
                                <span  style="float:right">¥ {{toFixed(item.legal_amount,2)}}</span>
                            </p>
                        </div>
                </div>
                
                <Scroll
                    style=" padding-top: 1rem;"
                    v-show="data.length>0"
                    @timer="timer"
                    :moreTit="bottomText"
                    ref="mychild"
                />
                <div style=" padding-bottom: 5rem;"></div>
         </mt-loadmore>
         <div class="pickerPop" @touchmove.prevent>
            <!-- 年月日时分选择 -->
            <mt-datetime-picker
                lockScroll="true"
                ref="datePicker"
                v-model="dateVal"
                class="myPicker"
                type="datetime"
                year-format="{value}"
                month-format="{value}"
                date-format="{value}"
                hour-format="{value}"
                minute-format="{value}"
                second-format="{value}"
                @confirm="dateConfirm()">
            </mt-datetime-picker>
        </div>
         <div class="pickerPop" @touchmove.prevent>
            <!-- 年月日时分选择 -->
            <mt-datetime-picker
                lockScroll="true"
                ref="datePicker2"
                v-model="dateVal2"
                class="myPicker"
                type="datetime"
                year-format="{value}"
                month-format="{value}"
                date-format="{value}"
                hour-format="{value}"
                minute-format="{value}"
                second-format="{value}"
                @confirm="dateConfirm2()">
            </mt-datetime-picker>
        </div>
       </div>
</template>
<script>
import {toFixed} from '../../public/index.js'
import Scroll from "@/component/scroll";
import moment from  "moment"
import {Indicator, Loadmore} from 'mint-ui';

export default {
     components:{
        Scroll
    },
     data(){
        return {
            data:[],//初始数据
            isactive:1,//区分订单
            bottomText: '上拉加载更多...',
            curPage:1, //分页
            searchvalue:'', //模糊搜索
            selectedValue:'', //开始时间
            selectedValue2:'', //结束时间
            dateVal:'',
            dateVal2:''
        }
    },
      mounted(){
        this.onPullingDown()
    },
      destroyed(){
        
    },
    methods:{
        toFixed,
        moment,
        //下拉刷新
        loadTop() {
            setTimeout(()=>{
                  this.onPullingDown()
                  this.$refs.loadmore.onTopLoaded();
            },1000)
        },
       timer(){
            this.bottomText= '正在加载...'
            this.onPullingUp()
        },
        onPullingUp(){
            this.curPage++
            this.$axios.get(`/v1/traders/order/list/${this.isactive==1?'ended':'cancel'}?page=${this.curPage}&per_page=10&order=0&keyword=${this.searchvalue}&start=${this.selectedValue}&end=${this.selectedValue2}`).then(res=>{
                if(res.code==0){
                   if(res.data.length==0){
                        this.bottomText= '暂时没有了'
                       this.$refs.mychild.gets();
                   }else{
                       this.bottomText= '加载更多'
                       this.data = this.data.concat(res.data);
                       this.$refs.mychild.get();
                   }
               }
            })
        },
        //初始化数据
        onPullingDown(){
             Indicator.open();
             this.$axios.get(`/v1/traders/order/list/${this.isactive==1?'ended':'cancel'}?page=1&per_page=10&order=0&keyword=${this.searchvalue}&start=${this.selectedValue}&end=${this.selectedValue2}`).then(res=>{
                    Indicator.close();
                    if(res.code==0){
                        this.data =  res.data
                        console.log( this.data,' this.data')
                    }
             })
        },
        selectData () {
               if (this.selectedValue) {
                     this.dateVal = this.selectedValue
                } else {
                    this.dateVal = new Date()
                }
                this.$refs['datePicker'].open()
       },
        selectData2 () {
            if (this.selectedValue2) {
                this.dateVal2 = this.selectedValue2
            } else {
                this.dateVal2 = new Date()
            }
            this.$refs['datePicker2'].open()
       },
        dateConfirm () { // 时间选择器确定按钮，并把时间转换成我们需要的时间格式
             this.selectedValue = moment(this.dateVal).format("YYYY-MM-DD HH:SS")
        },
         dateConfirm2 () { // 时间选择器确定按钮，并把时间转换成我们需要的时间格式
             this.selectedValue2 = moment(this.dateVal2).format("YYYY-MM-DD HH:SS")
        },
        search(){
             this.curPage=1
             this.onPullingDown()
        },
        detail(id){
            this.$router.push({
                path:'/orderdetail',
                query:{orderid:id}
            })
        },
        //切换数据
        changeActive(idx){
            if(this.isactive==idx){
                return
            }
            this.curPage =1
            this.isactive = idx
             this.$refs.mychild.get();
            this.onPullingDown()
            
        }
    }
}
</script>


<style lang="scss" scoped>
.selectTime{
        margin:10px;
    }
    .ccpay-orderSates{
        // padding-bottom:3rem;
    }
    .ccpay-order-tab{
            font-weight: 500;
             position: fixed;
            top: 0;
            z-index: 999;
            height: 3rem;
            line-height: 3rem;
            width: 100%;
            // padding: 1rem;
            background: white;
            display: flex;
            // padding-left:2rem;
            justify-content: space-around;
            border-bottom:1px solid #ccc;
            padding-bottom:0.2rem;
            div{
                // flex: 1;
                // margin-right: 3rem;
                text-align: center;
                .class-tab-sp{
                    background: #20ABFE;
                    padding: 8px;
                    padding-left: 16px;
                    padding-right: 16px;
                    color: white;
                    font-size: 14px;
                    border-radius: 10px;
                    
                }
            }
    }
    .ccpay-order-content{
            padding:1rem;
            // padding-bottom: 0;
              padding-bottom:0rem;
    }
    .ccapy-order-card{
            color: #666666;
            -webkit-transform: translateZ(0px);
            transform: translateZ(0px);
            font-size: 14px;
            // -webkit-box-shadow: rgba(0, 0, 0, 0.12) 0px 4px 16px;
            // box-shadow: rgba(0, 0, 0, 0.12) 0px 4px 16px;
            // border-radius: 8px;
            // transition: transform 500ms cubic-bezier(0.12, 0.72, 0.29, 1) 0s, -webkit-transform 500ms cubic-bezier(0.12, 0.72, 0.29, 1) 0s;
            border-bottom: 1px solid #ccc;
            position: relative;
            padding: 1.5rem;
            padding-bottom: 0.01rem;
            p{
                margin-bottom: 1rem;
            }
           .ccpay-order-card-hed{
                display: flex;
                justify-content: space-between;
                span{
                    // margin-right: .8rem;
                    font-size: 0.9rem;
                    // font-size: 1rem;
                }
                .c-o-bg-r{
                    color: #E08DA1;
                    background: #FFF7FA;
                    padding: 7px;
                    border-radius: 10px;
                }
                .c-r-c-g{
                    color: #54BCA5;
                    
                }
                .c-r-c-b{
                    color:black;
                }
                .c-r-c-br{
                    color:#CA595B;
                    margin-right: 0;
                    // font-weight: 600;
                }
           }
            background: white;
            .ccpay-order-c-spbed{
                display: flex;
                justify-content: space-between;
            }
            .ccpay-order-c-canle{
                background: #20ABFE;
                padding: 6px;
                border: none;
                padding-left: 1rem;
                padding-right: 1rem;
                color: white;
                border-radius: 2px;
            }
    }
    .ccpay-cls-act-div{
                position: absolute;
                width: 100%;
                height: 100%;
                background: gold;
                opacity: 0.2;
                top: 0;
                left: 0;
        }
</style>


// WEBPACK FOOTER //
// src/components/index/orderlislist.vue